import { compareRows } from '@/mocks/homeData';

const columns = [
  { key: 'cn', label: '中文版' },
  { key: 'mandarin', label: '国语版' },
  { key: 'subtitle', label: '中文字幕' },
  { key: 'online', label: '字幕在线' },
] as const;

export default function VersionCompare() {
  return (
    <section id="compare" className="w-full scroll-mt-28 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="font-label text-xs font-medium uppercase tracking-widest text-primary-600">
            Compare
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            版本对比：五个维度看清差异
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            下表按用途、语言风格、呈现形式、是否需下载与适合人群，对四种版本做了横向对照。
            表格在手机上可左右滑动查看完整内容。
          </p>
        </div>

        <div className="mt-8 overflow-x-auto rounded-lg border border-background-200 bg-background-50">
          <table className="w-full min-w-[720px] border-collapse text-left">
            <caption className="sr-only">善良的女秘书四种字幕与译制版本维度对比</caption>
            <thead>
              <tr className="bg-background-100">
                <th
                  scope="col"
                  className="w-32 px-5 py-4 font-label text-xs font-medium uppercase tracking-wide text-foreground-500"
                >
                  对比维度
                </th>
                {columns.map((col) => (
                  <th
                    key={col.key}
                    scope="col"
                    className="px-5 py-4 font-heading text-sm font-bold text-foreground-900"
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {compareRows.map((row, index) => (
                <tr
                  key={row.dimension}
                  className={index % 2 === 1 ? 'bg-background-100/60' : 'bg-background-50'}
                >
                  <th
                    scope="row"
                    className="px-5 py-4 align-top font-label text-sm font-medium text-foreground-800"
                  >
                    {row.dimension}
                  </th>
                  <td className="px-5 py-4 align-top text-sm text-foreground-700">{row.cn}</td>
                  <td className="px-5 py-4 align-top text-sm text-foreground-700">{row.mandarin}</td>
                  <td className="px-5 py-4 align-top text-sm text-foreground-700">{row.subtitle}</td>
                  <td className="px-5 py-4 align-top text-sm text-foreground-700">{row.online}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}